import {
  Box,
  Button,
  Center,
  Heading,
  Link,
  FormControl,
  FormLabel,
  Input,
  IconButton,
  InputGroup,
  InputRightElement,
  Text,
  Alert,
  AlertIcon
} from "@chakra-ui/react";
import { Component } from "react";
import { Overlay } from "../Overlay/Overlay";
import { IoIosEye, IoIosEyeOff } from "react-icons/all";
import { BeatLoader } from "react-spinners";
import { SetupPasswordState } from "../modals/StateInterface/SetupPasswordState";
import { SetupPasswordProp } from "../modals/PropInterface/SetupPasswordProp";
import APIService from "../Services/APIService";
import { NotifyService } from "../Services/NotifyService";
import { CommonMethodService } from "../Services/CommonMethodService";

export default class SetupPassword extends Component<
  SetupPasswordProp,
  SetupPasswordState
> {
  private apiService = new APIService();
  private notifyService = new NotifyService();
  private commonMethodService = new CommonMethodService();

  constructor(props: SetupPasswordProp) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: "",
      oldPassword: "",
      isValid: false,
      newPasswordIsValid: false,
      confirmPasswordIsValid: false,
      oldPasswordIsValid: false,
      passwordsMatch: true,
      showPassword: false,
      showConfirmPassword: false,
      showOldPassword: false,
      showButtonLoader: false,
      isEmailDisabled: this.props?.email ? true : false,
      passwordError: "",
      confirmPasswordError: "",
      oldPasswordError: "",
      isShowErrorMessage: false,
      errorMessage: ""
    };
  }

  handlePasswordChange = (event: any) => {
    const newPassword = event.currentTarget.value;
    this.setState({
      password: newPassword,
      newPasswordIsValid: this.validatePassword(newPassword, "new")
    });
  };

  handleConfirmPasswordChange = (event: any) => {
    const newConfirmPassword = event.currentTarget.value;
    this.setState({
      confirmPassword: newConfirmPassword,
      confirmPasswordIsValid:
        this.validatePassword(newConfirmPassword, "confirm") &&
        this.state.password === newConfirmPassword,
      passwordsMatch: this.state.password === newConfirmPassword
    });
  };

  handleOldPasswordChange = (event: any) => {
    const oldPassword = event.currentTarget.value;
    this.setState({
      oldPassword,
      oldPasswordIsValid: this.validatePassword(oldPassword, "old")
    });
  };

  validatePassword = (password: any, type: string) => {
    const passwordRegex = /^(?=.*\d)(?=.*[A-Z]).{8,20}$/;
    if (!passwordRegex.test(password)) {
      if (type === "old") {
        this.setState({
          oldPasswordError:
            "Password must be between 8 and 20 characters, contain at least 1 uppercase letter, and at least 1 digit."
        });
      } else {
        this.setState({
          passwordError:
            "Password must be between 8 and 20 characters, contain at least 1 uppercase letter, and at least 1 digit.",
          confirmPasswordError: ""
        });
      }

      return false;
    } else if (
      this.state.confirmPassword &&
      password !== this.state.password &&
      type === "confirm"
    ) {
      this.setState({
        confirmPasswordError: "Passwords do not match.",
        passwordError: ""
      });
      return false;
    } else if (
      this.state.confirmPassword &&
      password !== this.state.confirmPassword &&
      type === "new"
    ) {
      this.setState({
        confirmPasswordError: "Passwords do not match.",
        passwordError: ""
      });
      return false;
    } else {
      if (type === "old") {
        this.setState({ oldPasswordError: "" });
      } else {
        this.setState({ passwordError: "", confirmPasswordError: "" });
      }
      return true;
    }
  };

  handleSubmit = async (event: any) => {
    event.preventDefault();
    if (
      this.state.newPasswordIsValid &&
      this.state.confirmPasswordIsValid &&
      (!this.props.changePassword || this.state.oldPasswordIsValid)
    ) {
      this.setState({ showButtonLoader: true });
      if (this.props.changePassword) {
        const data = {
          password: this.state.oldPassword,
          newPassword: this.state.password
        };
        await this.apiService.changePassword(data).then(async (res) => {
          const result = await res.json();
          if (res.ok) {
            this.notifyService.successNotitifcation(
              "Password changed successfully"
            );
            this.props.closeDialog();
          } else {
            this.notifyService.errorNotitifcation(
              result.error ? result.error : "Please try it again"
            );

            this.setState({
              isShowErrorMessage: true,
              errorMessage: result.error ? result.error : "Please try it again"
            });
          }
        });
      } else {
        const data = {
          password: this.state.password,
          password_confirmation: this.state.confirmPassword,
          email: this.props?.email
        };
        await this.apiService.sendResetPassword(data).then(async (res) => {
          const result = await res.json();
          if (res.ok) {
            let currentUser =
              this.commonMethodService.getDataFromStorage("currentUser");
            if (result.is_active) {
              this.props.ibsService.currentUser.user.is_active =
                result.is_active;
              currentUser.user.is_active = result.is_active;
              this.commonMethodService.setDataIntoStorage(
                "currentUser",
                currentUser
              );
              this.notifyService.successNotitifcation(
                "Set password successfully"
              );
              this.props.closeDialog();
            } else {
              this.setState({
                isShowErrorMessage: true,
                errorMessage: "Password not set, Please try it again"
              });
              this.notifyService.errorNotitifcation(
                "Password not set, Please try it again"
              );
            }
          } else {
            this.setState({
              isShowErrorMessage: true,
              errorMessage: "Password not set, Please try it again"
            });
            this.notifyService.errorNotitifcation(
              "Password not set, Please try it again"
            );
          }
        });
      }

      this.setState({ showButtonLoader: false });
    }
  };

  render() {
    return (
      <Overlay isMenuOverlay={false} isDialogOverlay={true}>
        <Center className="defaultBG" style={{ width: "80rem" }}>
          <Box
            maxW={["sm", null, "4xl"]}
            p={12}
            bg="white"
            boxShadow="lg"
            m="auto"
            borderRadius="md"
            className="d-flex flex-column"
            style={{ width: "80rem" }}
          >
            <div className="w-100">
              <Heading color="blue.700">Flow Autobody</Heading>

              <Text
                fontSize="xl"
                fontWeight={"bold"}
                color={"blue.400"}
                mb={4}
                mt={4}
              >
                {this.props.changePassword
                  ? "Change your password"
                  : "Setup your password"}
              </Text>
              <Text
                fontSize="md"
                fontWeight={"bold"}
                color={"black.400"}
                mb={4}
                mt={4}
              >
                {this.props?.name}
              </Text>
              <form onSubmit={this.handleSubmit}>
                <FormControl mt={4}>
                  <FormLabel>Email</FormLabel>
                  <Input
                    style={{ borderColor: "black" }}
                    type="text"
                    id="email"
                    value={this.props?.email}
                    disabled={this.state.isEmailDisabled}
                  />
                </FormControl>
                {this.props.changePassword && (
                  <FormControl mt={4}>
                    <FormLabel>Old Password</FormLabel>

                    <InputGroup>
                      <Input
                        style={{ borderColor: "black" }}
                        type={this.state.showOldPassword ? "text" : "password"}
                        id="password"
                        value={this.state.oldPassword}
                        onChange={this.handleOldPasswordChange}
                      />
                      <InputRightElement>
                        <IconButton
                          icon={
                            this.state.showOldPassword ? (
                              <IoIosEyeOff />
                            ) : (
                              <IoIosEye />
                            )
                          }
                          onClick={() => {
                            this.setState({
                              showOldPassword: !this.state.showOldPassword
                            });
                          }}
                          aria-label="Toggle password visibility"
                          variant="outline"
                          colorScheme="black"
                          size="sm"
                        />
                      </InputRightElement>
                    </InputGroup>
                    {this.state.oldPasswordError && (
                      <Text
                        className="d-flex justify-content-start"
                        fontSize={"x-small"}
                        color="red.500"
                      >
                        {this.state.oldPasswordError}
                      </Text>
                    )}
                  </FormControl>
                )}
                <FormControl mt={4}>
                  <FormLabel>New Password</FormLabel>

                  <InputGroup>
                    <Input
                      style={{ borderColor: "black" }}
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      value={this.state.password}
                      onChange={this.handlePasswordChange}
                    />
                    <InputRightElement>
                      <IconButton
                        icon={
                          this.state.showPassword ? (
                            <IoIosEyeOff />
                          ) : (
                            <IoIosEye />
                          )
                        }
                        onClick={() => {
                          this.setState({
                            showPassword: !this.state.showPassword
                          });
                        }}
                        aria-label="Toggle password visibility"
                        variant="outline"
                        colorScheme="black"
                        size="sm"
                      />
                    </InputRightElement>
                  </InputGroup>
                  {this.state.passwordError && (
                    <Text
                      className="d-flex justify-content-start"
                      fontSize={"x-small"}
                      color="red.500"
                    >
                      {this.state.passwordError}
                    </Text>
                  )}
                </FormControl>
                <FormControl mt={4}>
                  <FormLabel>Confirm Password</FormLabel>
                  <InputGroup>
                    <Input
                      style={{ borderColor: "black" }}
                      type={
                        this.state.showConfirmPassword ? "text" : "password"
                      }
                      id="confirmPassword"
                      value={this.state.confirmPassword}
                      onChange={this.handleConfirmPasswordChange}
                    />
                    <InputRightElement>
                      <IconButton
                        icon={
                          this.state.showConfirmPassword ? (
                            <IoIosEyeOff />
                          ) : (
                            <IoIosEye />
                          )
                        }
                        onClick={() => {
                          this.setState({
                            showConfirmPassword: !this.state.showConfirmPassword
                          });
                        }}
                        aria-label="Toggle password visibility"
                        variant="outline"
                        colorScheme="black"
                        size="sm"
                      />
                    </InputRightElement>
                  </InputGroup>
                  {this.state.confirmPasswordError && (
                    <Text
                      className="d-flex justify-content-start"
                      fontSize={"x-small"}
                      color="red.500"
                    >
                      {this.state.confirmPasswordError}
                    </Text>
                  )}
                </FormControl>
                <Box className="my-2">
                  {this.state.isShowErrorMessage && (
                    <Alert
                      borderRadius={4}
                      status="error"
                      variant="subtle"
                      alignItems={"start"}
                      textAlign={"left"}
                    >
                      <AlertIcon />
                      {this.state.errorMessage}
                    </Alert>
                  )}
                </Box>
                <div className="my-4 d-flex justify-content-around">
                  <Button
                    w="40%"
                    colorScheme={"blue"}
                    variant="outline"
                    onClick={() => this.props.closeDialog()}
                  >
                    Close
                  </Button>
                  <Button
                    isLoading={this.state.showButtonLoader}
                    w="40%"
                    colorScheme={"red"}
                    variant="outline"
                    type="submit"
                    // disabled={!this.state.isValid}
                    spinner={<BeatLoader size={8} color="red" />}
                  >
                    {this.props.changePassword
                      ? "Change password"
                      : "Setup password"}
                  </Button>
                </div>
              </form>
              <Box mt={4}>
                Having trouble signing in?
                <br />
                Contact customer support at{" "}
              </Box>
              <Link
                style={{ textDecoration: "underline" }}
                href="mailto:hello@flowautobody.com.au"
              >
                hello@flowautobody.com.au
              </Link>
            </div>
          </Box>
        </Center>
      </Overlay>
    );
  }
}
